<div class="block-title d-md-none">Контакты</div>

<div class="block">
  <h2 class="d-none d-md-block">Контакты</h2>
  <form class="contact-block" (submit)="onSubmit()" [formGroup]="form">
    <div class="phones">
      <sd-form-field-new required="true" label="Номер телефона" [control]="form.get('phone')">
        <input
          type="tel"
          class="phone-control"
          sdPhoneMaskFix
          required="true"
          formControlName="phone"
          sdPhoneAuthorizedUser
        />
      </sd-form-field-new>
      <sd-form-field-new label="Еще номер, если хотите">
        <input type="tel" class="phone-control" sdPhoneMaskFix formControlName="addPhone" />
      </sd-form-field-new>
    </div>
    <sd-form-field-new label="Почта, если хотите">
      <input type="email" formControlName="email" placeholder="Email" />
      <cx-form-errors [control]="form.get('email')"></cx-form-errors>
    </sd-form-field-new>
  </form>

  <sd-submit-order *ngIf="(isMobile$ | async) === false" class="send-btn"></sd-submit-order>

  <div *ngIf="placeOrderError$ | async" class="place-order-error alert alert-danger" role="alert">
    Заказ не может быть оформлен, в вашей корзине нет товаров. Перейдите в
    <a [routerLink]="{ cxRoute: 'category', params: { code: 'catalog' } } | cxUrl">каталог</a>
  </div>
</div>
